<script>
import publish from './publish.table'
import getExportedFilename from '../../utils/get-exported-filename'

export default {
  name: 'Publish',
  data() {
    return {
      table: publish(this),
    }
  },
  methods: {
    refreshTable() {
      this.table.processor.updatePage(1)
      this.table.processor.getData()
    },
    getExportedFilename() {
      return getExportedFilename(this.table.tableName)
    },
  },
}
</script>

<template>
  <main-layout title="Publish">
    <table-layout
      :table-name="table.tableName"
      :processor="table.processor"
      :filters="table.filters"
      :columns="table.columns"
      :fragments="false"
      hider
      :class="$style.table"
      :quantity="[25, 50, 100, 200]"
      :export-filename="getExportedFilename"
    >
      <template slot="features">
        <el-button
          size="small"
          type="secondary"
          :disabled="false"
          :loading="false"
          icon="el-icon-refresh-right"
          @click="refreshTable"
        >
          Refresh
        </el-button>
      </template>
    </table-layout>
  </main-layout>
</template>

<style lang="scss" module>
  .table {
    colgroup > col:first-child {
      width: rem(120px);
    }
  }

  .subrow {
    margin-bottom: 10px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  .warning {
    color: #fc1e1e;
  }
</style>
